import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

//连续点击多次路由报错解决方法
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  routes: [
    {
      path: '/invest-detail',
      name: 'investDetail',
      component: () => import('@/views/invest/index.vue'),
      meta: {
        title: '投资详情',
        active: 'invest'
      }
    },
    {
      path: '/invest',
      name: 'invest',
      component: () => import('@/views/invest/list.vue'),
      meta: {
        title: '投资',
        active: 'invest'
      }
    },
    {
      path: '/blindBox',
      name: 'blindBox',
      component: () => import('@/views/special/blindBox.vue'),
      meta: {
        requiresAuth: true,
        title: '盲盒活动',
        active: 'activity'
      }
    },
    {
      path: '/coupon',
      name: 'coupon',
      component: () => import('@/views/coupon/index.vue'),
      meta: {
        requiresAuth: true,
        title: '优惠券',
        active: 'coupon'
      }
    },
    {
      path: '/game',
      name: 'game',
      component: () => import('@/views/Game.vue'),
      meta: {
        requiresAuth: true,
        title: '娱乐大厅',
        active: 'game'
      }
    },
    {
      path: '/bet/:playLottery',
      name: 'bet',
      component: () => import('@/views/bet/betRoom.vue'),
      meta: {
        requiresAuth: true,
        title: '投注',
        active: 'bet'
      },
      props: true
    },
    {
      path: '/activityDetail/:activityId',
      name: 'activityDetail',
      component: () => import('@/views/activity/detail.vue'),
      meta: {
        requiresAuth: true,
        title: '活动详情',
        active: 'activity'
      },
      props: true
    },
    {
      path: '/activity',
      name: 'activity',
      component: () => import('@/views/activity/index.vue'),
      meta: {
        requiresAuth: true,
        title: '活动',
        active: 'activity'
      },
      props: true
    },
    {
      path: '/splashWater',
      name: 'splashWater',
      component: () => import('@/views/special/splashWater.vue'),
      meta: {
        requiresAuth: true,
        title: '泼水活动',
        active: 'activity'
      }
    },
    {
      path: '/community',
      name: 'community',
      component: () => import('@/views/community/index.vue'),
      meta: {
        requiresAuth: true,
        title: '社区',
        active: 'community'
      }
    },
    {
      path: '/shareDetail/:shareId/:shareType/:shareDan?',
      name: 'shareDetail',
      component: () => import('@/views/share/detail.vue'),
      meta: {
        requiresAuth: true,
        title: '分享详情',
        active: 'share'
      },
      props: true
    },
    {
      path: '/shareStep/:shareId',
      name: 'shareStep',
      component: () => import('@/views/share/step.vue'),
      meta: {
        requiresAuth: true,
        title: '分享步骤',
        active: 'share'
      },
      props: true
    },
    {
      path: '/share',
      name: 'share',
      component: () => import('@/views/share/index.vue'),
      meta: {
        requiresAuth: true,
        title: '分享任务',
        active: 'share'
      },
    },
    {
      path: '/joinPartner',
      name: 'joinPartner',
      component: () => import('@/views/partner/join.vue'),
      meta: {
        requiresAuth: true,
        title: '参与众筹',
        active: 'partner'
      },
    },
    {
      path: '/myPartner',
      name: 'myPartner',
      component: () => import('@/views/partner/my.vue'),
      meta: {
        requiresAuth: true,
        title: '我的众筹',
        active: 'partner'
      },
    },
    {
      path: '/partner',
      name: 'partner',
      component: () => import('@/views/partner/index.vue'),
      meta: {
        requiresAuth: true,
        title: '众筹',
        active: 'partner'
      },
    },
    {
      path: '/video',
      name: 'video',
      component: () => import('@/views/video/index.vue'),
      meta: {
        requiresAuth: true,
        title: '视频',
        active: 'video'
      },
    },
    {
      path: '/forgetPass/:verifyType',
      name: 'forgetPass',
      component: () => import('@/views/ForgetPass'),
      meta: {
        title: '忘记密码',
        active: 'forgetPass'
      },
      props: true
    },
    {
      path: '/finance',
      name: 'finance',
      component: () => import('@/views/finance/index.vue'),
      meta: {
        requiresAuth: true,
        title: '理财',
        active: 'finance'
      }
    },
    {
      path: '/financeDetail/:financeId',
      name: 'financeDetail',
      component: () => import('@/views/finance/detail.vue'),
      meta: {
        requiresAuth: true,
        title: '理财详情',
        active: 'finance'
      },
      props: true
    },
    {
      path: '/financeOrder',
      name: 'financeOrder',
      component: () => import('@/views/finance/order.vue'),
      meta: {
        requiresAuth: true,
        title: '理财订单',
        active: 'finance'
      }
    },
    {
      path: '/financeOrder/:orderId',
      name: 'financeOrderDetail',
      component: () => import('@/views/finance/orderDetail.vue'),
      meta: {
        requiresAuth: true,
        title: '订单详情',
        active: 'finance'
      },
      props: true
    },
    {
      path: '/serviceCenter/:tabsActive?',
      name: 'serviceCenter',
      component: () => import('@/views/ServiceCenter.vue'),
      meta: {
        title: '客服中心',
        active: 'service'
      },
      props: true
    },
    {
      path: '/profit',
      name: 'profit',
      component: () => import('@/views/Profit.vue'),
      meta: {
        requiresAuth: true,
        title: '会员收益',
        active: 'profit'
      }
    },
    {
      path: '/help',
      name: 'help',
      component: () => import('@/views/Help.vue'),
      meta: {
        title: '帮助手册',
        active: 'help'
      }
    },
    {
      path: '/article/:articleType/:articleId?',
      name: 'article',
      component: () => import('@/views/Article.vue'),
      meta: {
        title: '内容',
        active: 'article'
      },
      props: true
    },
    {
      path: '/service',
      name: 'service',
      component: () => import('@/views/Service.vue'),
      meta: {
        title: '在线客服',
        active: 'service'
      }
    },
    {
      path: '/line',
      name: 'line',
      component: () => import('@/views/Line.vue'),
      meta: {
        title: '切换线路',
        active: 'line'
      }
    },
    {
      path: '/language',
      name: 'language',
      component: () => import('@/views/Language.vue'),
      meta: {
        title: '选择语言',
        active: 'language'
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        title: '用户登录',
        active: 'login'
      }
    },
    {
      path: '/register/:recommendId?',
      name: 'register',
      component: () => import('@/views/Register.vue'),
      meta: {
        title: '用户注册',
        active: 'register'
      },
      props: true
    },
    {
      path: '/',
      name: 'home',
      component:  () => import('@/views/Home.vue'),
      meta: {
        requiresAuth: true,
        title: '首页',
        active: 'home'
      }
    },
    {
      path: '/task/:tabsActive?',
      name: 'task',
      component: () => import('@/views/task/index.vue'),
      meta: {
        title: '任务',
        active: 'task'
      },
      props: true
    },
    {
      path: '/taskList/:taskType/:taskGrade',
      name: 'taskList',
      component: () => import('@/views/task/list.vue'),
      meta: {
        title: '任务列表',
        active: 'task'
      },
      props: true
    },
    {
      path: '/taskShow/:taskId',
      name: 'taskShow',
      component: () => import('@/views/task/show.vue'),
      meta: {
        title: '任务详情',
        active: 'task'
      },
      props: true
    },
    {
      path: '/vip',
      name: 'vip',
      component: () => import('@/views/Vip.vue'),
      meta: {
        requiresAuth: true,
        title: 'VIP',
        active: 'vip'
      }
    },
    {
      path: '/appDown',
      name: 'appDown',
      component: () => import('@/views/AppDown.vue'),
      meta: {
        title: 'APP下载',
        active: 'appDown'
      }
    },
    {
      path: '/user',
      name: '',
      component: () => import('@/views/UserCenter.vue'),
      meta: {
        requiresAuth: true,
        title: '会员中心',
        active: 'user'
      },
      children: [
        {
          path: 'investOrder',
          name: 'investOrder',
          component: () => import('@/views/invest/order.vue'),
          meta: {
            title: '我的投资',
            active: 'user'
          }
        },
        {
          path: 'investOrder/:orderId',
          name: 'investOrder',
          component: () => import('@/views/invest/detail.vue'),
          meta: {
            title: '投资详情',
            active: 'user'
          },
          props: true
        },
        {
          path: 'contract/:orderId',
          name: 'investOrder',
          component: () => import('@/views/invest/contract.vue'),
          meta: {
            title: '投资合同',
            active: 'user'
          },
          props: true
        },
        {
          path: 'coupon/:vipGrade?',
          name: 'myCoupon',
          component: () => import('@/views/user/coupon.vue'),
          meta: {
            title: '我的优惠券',
            active: 'user'
          }
        },
        {
          path: '',
          name: 'user',
          component: () => import('@/views/user/index.vue'),
          meta: {
            title: '会员中心',
            active: 'user'
          }
        },
        {
          path: 'taskOrder/:taskState?',
          name: 'taskOrder',
          component: () => import('@/views/user/taskOrder.vue'),
          meta: {
            title: '我的任务',
            active: 'taskOrder'
          },
          props: true
        },
        {
          path: 'info',
          name: 'info',
          component: () => import('@/views/user/info.vue'),
          meta: {
            title: '个人信息',
            active: 'user'
          }
        },
        {
          path: 'set/:setType',
          name: 'set',
          component: () => import('@/views/user/set.vue'),
          meta: {
            title: '用户设置',
            active: 'user'
          },
          props: true
        },
        {
          path: 'postTask/:taskId?',
          name: 'postTask',
          component: () => import('@/views/user/postTask.vue'),
          meta: {
            title: '发布任务'
          },
          props: true
        },
        {
          path: 'postRecord/:taskType?',
          name: 'postRecord',
          component: () => import('@/views/user/postRecord.vue'),
          meta: {
            title: '发布管理',
          },
          props: true
        },
        {
          path: 'taskInfo/:orderId',
          name: 'taskInfo',
          component: () => import('@/views/user/taskInfo.vue'),
          meta: {
            title: '任务详情',
          },
          props: true
        },
        {
          path: 'auditRecord/:taskState?',
          name: 'auditRecord',
          component: () => import('@/views/user/auditRecord.vue'),
          meta: {
            title: '审核任务',
          },
          props: true
        },
        {
          path: 'auditInfo/:auditId',
          name: 'auditInfo',
          component: () => import('@/views/user/auditInfo.vue'),
          meta: {
            title: '审核详情',
          },
          props: true
        },
        {
          path: 'dayReport',
          name: 'dayReport',
          component: () => import('@/views/user/dayReport.vue'),
          meta: {
            title: '日结报表',
            active: 'user'
          }
        },
        {
          path: 'teamReport',
          name: 'teamReport',
          component: () => import('@/views/user/teamReport.vue'),
          meta: {
            title: '团队报表',
            active: 'user'
          }
        },
        {
          path: 'fundRecord/:fundState?',
          name: 'fundRecord',
          component: () => import('@/views/user/fundRecord.vue'),
          meta: {
            title: '账变记录',
            active: 'user'
          },
          props: true
        },
        {
          path: 'bankCard',
          name: 'bankCard',
          component: () => import('@/views/user/bankCard.vue'),
          meta: {
            title: '我的银行卡',
            active: 'user'
          }
        },
        {
          path: 'wallet/:walletType?',
          name: 'wallet',
          component: () => import('@/views/user/wallet.vue'),
          meta: {
            title: '我的钱包',
            active: 'user'
          },
          props: true
        },
        {
          path: 'withdraw',
          name: 'withdraw',
          component: () => import('@/views/user/withdraw.vue'),
          meta: {
            title: '我要提现',
            active: 'user'
          }
        },
        {
          path: 'recharge/:rechargeId?',
          name: 'recharge',
          component: () => import('@/views/user/recharge.vue'),
          meta: {
            title: '我要充值',
            active: 'user'
          },
          props: true
        },
        {
          path: 'promote/:isReward?',
          name: 'promote',
          component: () => import('@/views/user/promote.vue'),
          meta: {
            title: '我的推广',
            active: 'user'
          },
          props: true
        },
        {
          path: 'bindAccount',
          name: 'bindAccount',
          component: () => import('@/views/user/bindAccount.vue'),
          meta: {
            title: '绑定账号',
            active: 'user'
          }
        },
        {
          path: 'credit',
          name: 'credit',
          component: () => import('@/views/user/credit.vue'),
          meta: {
            title: '信用中心',
            active: 'user'
          }
        },
        {
          path: 'robot',
          name: 'robot',
          component: () => import('@/views/user/robot.vue'),
          meta: {
            title: '云管家',
            active: 'user'
          }
        },
      ]
    },
    {
      path: '/404',
      name:'404'
    },
    {
        path: '*',
        redirect: '/404'
    },
  ]
})

export default router
